import { Form, Input } from 'antd';
import classNames from 'classnames';
import type { FC } from 'react';

import { Mode } from 'app/components/commons/Hotel/Types';

import './CoverLabel.scss';

export type CoverData = {
  coverLabel1?: string;
  coverLabel2?: string;
};

type Props = {
  mode?: Mode;
  values?: CoverData;
};

export const CoverLabel: FC<Props> = ({ mode = Mode.View, values }) => {
  return (
    <div className="cover-labels">
      {mode === Mode.Edit ? (
        <div className="input-row">
          <Form.Item name="coverLabel1" label="First line">
            <Input />
          </Form.Item>
          <Form.Item name="coverLabel2" label="Second line">
            <Input />
          </Form.Item>
        </div>
      ) : (
        <div className="input-row input-row-no-rules">
          <Form.Item name="coverLabel1" label="First line">
            <span
              className={classNames('view-text', {
                'view-text-empty': !values?.coverLabel1,
              })}
            >
              {values?.coverLabel1 || 'ø empty'}
            </span>
          </Form.Item>
          <Form.Item name="coverLabel2" label="Second line">
            <span
              className={classNames('view-text', {
                'view-text-empty': !values?.coverLabel2,
              })}
            >
              {values?.coverLabel2 || 'ø empty'}
            </span>
          </Form.Item>
        </div>
      )}
    </div>
  );
};
